import React from 'react';
import { toast } from 'react-toastify';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { IReqLabels, IResLabelsData, IResLabelsOK } from '@/types/parcel/orders/labels.interface';

interface ILabels {
  cleanTrackingIds?: () => void;
  onCloseModal?: () => void;
}

const useLabels = (args: ILabels) => {
  const http = initializeHttpProvider();
  const [loading, setLoading] = React.useState(false);
  const [errorOrders, setErrorOrders] = React.useState<
    Pick<IResLabelsData, 'draftOrders' | 'nonExistentOrders'>
  >({
    draftOrders: [],
    nonExistentOrders: [],
  });

  const downloadLabels = async ({ pageSize, trackingIds }: IReqLabels) => {
    setLoading(true);
    http.orders
      .labels({ pageSize, trackingIds })
      .then((res) => {
        const response = res as IResLabelsOK;
        setErrorOrders({
          draftOrders: response.data.draftOrders,
          nonExistentOrders: response.data.nonExistentOrders,
        });
        window.open(response.data.url, '_blank');
        toast.success('Etiqueta descargada');
        args.cleanTrackingIds?.();
        args.onCloseModal?.();
      })
      .catch(() => {
        setErrorOrders({
          draftOrders: [],
          nonExistentOrders: [],
        });
        toast.error('Error al descargar la etiqueta');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    loading,
    downloadLabels,
    errorOrders,
  };
};

export default useLabels;
